'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.demand_report_index', {
        url: 'demand_report',
        template: '<demand_report_index></demand_report_index>'
    });
}



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/index/demand_report_index.routes.js